module.exports = __webpack_public_path__ + "static/media/hero.dcc34059.png";